<template>
  <div class="condition-list">
    <div v-for="(item, index) in conditionList" :key="index" class="condition-row mb10">
      <a-row :gutter="8">
        <a-col :span="8">
          <a-select
            v-model="item.condition_type"
            show-search
            option-filter-prop="children"
            :placeholder="$t('请选择字段')"
            size="small"
            style="width: 100%"
            @change="(val) => handleFieldChange(item, val)"
          >
            <a-select-option
              v-for="field in fields"
              :key="field.field_code"
              :value="field.field_code"
            >
              {{ field.field_name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <a-select
            v-model="item.condition_express"
            size="small"
            style="width: 100%"
            :placeholder="$t('关系')"
            @change="() => handleExpressChange(item)"
          >
            <a-select-option v-for="exp in condition_express" :key="exp.code" :value="exp.code">
              {{ exp.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <a-select
            v-model="item.condition_value_type"
            size="small"
            style="width: 100%"
            :placeholder="$t('值类型')"
            @change="() => handleValueTypeChange(item)"
          >
            <a-select-option v-for="vt in conditionValueTypes" :key="vt.code" :value="vt.code">
              {{ vt.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="7">
          <a-select
            v-if="isFieldValue(item)"
            :value="item.condition_value"
            show-search
            option-filter-prop="children"
            size="small"
            style="width: 100%"
            :placeholder="$t('请选择字段')"
            @change="(val) => handleValueChange(item, val)"
          >
            <a-select-option
              v-for="field in fields"
              :key="field.field_code"
              :value="field.field_code"
            >
              {{ field.field_name }}
            </a-select-option>
          </a-select>
          <a-select
            v-else-if="fieldValueOptions[item.condition_type]"
            :value="
              isMultiple(item.condition_express)
                ? item.condition_value
                  ? item.condition_value.split(',')
                  : []
                : item.condition_value
            "
            :mode="isMultiple(item.condition_express) ? 'multiple' : 'default'"
            show-search
            option-filter-prop="children"
            size="small"
            style="width: 100%"
            :placeholder="$t('请选择值')"
            @change="(val) => handleValueChange(item, val)"
          >
            <a-select-option
              v-for="opt in fieldValueOptions[item.condition_type]"
              :key="opt.value_code"
              :value="opt.value_code"
            >
              {{ opt.value_name }}
            </a-select-option>
          </a-select>
          <a-select
            v-else-if="isMultiple(item.condition_express)"
            :value="item.condition_value ? item.condition_value.split(',') : []"
            mode="tags"
            size="small"
            style="width: 100%"
            :placeholder="$t('请输入值，按回车添加')"
            @change="(val) => handleValueChange(item, val)"
          />
          <a-input
            v-else
            v-model="item.condition_value"
            size="small"
            :placeholder="$t('请输入值')"
          />
        </a-col>
        <a-col :span="1">
          <a-button type="link" size="small" class="text-danger" @click="$emit('remove', index)">
            <a-icon type="delete" />
          </a-button>
        </a-col>
      </a-row>
    </div>
    <a-button type="dashed" block size="small" @click="$emit('add')">
      <a-icon type="plus" />
      {{ $t('添加条件') }}
    </a-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'

export default {
  name: 'ConditionList',
  props: {
    conditionList: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    docCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fieldValueOptions: {},
    }
  },
  computed: {
    ...mapState(['condition_express']),
    conditionValueTypes() {
      return [
        { code: 'FIXED', name: this.$t('固定值') },
        { code: 'FIELD', name: this.$t('字段') },
      ]
    },
  },
  watch: {
    conditionList: {
      immediate: true,
      handler(list) {
        if (list && list.length > 0) {
          list.forEach((item) => {
            if (!item.condition_value_type) {
              this.$set(item, 'condition_value_type', 'FIXED')
            }
            if (
              item.condition_value_type === 'FIXED' &&
              item.condition_type &&
              !this.fieldValueOptions[item.condition_type]
            ) {
              this.fetchFieldValues(item.condition_type)
            }
          })
        }
      },
    },
  },
  methods: {
    isMultiple(type) {
      return ['IN', 'NOT_IN'].includes(type.toUpperCase())
    },
    isFieldValue(item) {
      return item.condition_value_type === 'FIELD'
    },
    handleValueTypeChange(item) {
      item.condition_value = ''
      if (item.condition_value_type === 'FIXED' && item.condition_type) {
        this.fetchFieldValues(item.condition_type)
      }
    },
    handleFieldChange(item, val) {
      item.condition_value = ''
      if (!this.isFieldValue(item)) {
        this.fetchFieldValues(val)
      }
    },
    handleExpressChange(item) {
      if (
        !this.isMultiple(item.condition_express) &&
        item.condition_value &&
        item.condition_value.includes(',')
      ) {
        item.condition_value = item.condition_value.split(',')[0]
      }
    },
    handleValueChange(item, val) {
      if (Array.isArray(val)) {
        item.condition_value = val.join(',')
      } else {
        item.condition_value = val
      }
    },
    async fetchFieldValues(fieldCode) {
      if (!fieldCode) return
      let docCode = this.docCode
      if (fieldCode.includes('.')) {
        docCode = fieldCode.split('.')[0]
      }
      try {
        const res = await http({
          url: api.getFinanceDocumentFieldValue,
          data: {
            financeDocumentCode: docCode,
            fieldCode: fieldCode,
          },
        })
        if (res.result && Array.isArray(res.result) && res.result.length > 0) {
          this.$set(this.fieldValueOptions, fieldCode, res.result)
        } else {
          this.$set(this.fieldValueOptions, fieldCode, null)
        }
      } catch (err) {
        console.error(err)
        this.$set(this.fieldValueOptions, fieldCode, null)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mb10 {
  margin-bottom: 10px;
}
.text-danger {
  color: #ff4d4f;
}
</style>
